import React from "react";
import styles from "./footer.module.css";
import cv from "../assets/resume.pdf";
import {assets} from "../assets/assets";

const Footer = ({ toggle }) => {
  return (
    <footer className={styles.footer}>
      <span className={styles.button}>
        <button
          style={{
            backgroundColor: "transparent",
            borderRadius: "50%",
            color: "white",
            width:"100%"
          }}
          onClick={() => toggle(false)}
        >
          X
        </button>
      </span>
      <div className={styles.contacto}>
        <h3 className={styles.title}>Contacto</h3>
        <ul className={styles.list}>
          <li>
            Linkedin:{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.linkedin.com/in/karlof-soberon"
            >
              /karlof-soberon
            </a>
          </li>
          <li>
            Github:{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://github.com/karlofsd"
            >
              karlofsd
            </a>
          </li>
          <li>
            Instagram:{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/sober.kf"
            >
              @sober.kf
            </a>
          </li>
          <li>
            Mail:{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="mailto:sober.karlo@gmail.com"
            >
              sober.karlo@gmail.com
            </a>
          </li>
        </ul>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width:"50%"
        }}
      >
        <a className={styles.a} href={cv} target="_blank" rel="noreferrer">
          <img className={styles.icon} src={assets.download} alt="download" />
        </a>
        <span>Download CV</span>
      </div>
      <div className={styles.credits}>
        <h3 className={styles.title}>Credits</h3>
        <ul className={styles.list}>
          <li>
            <a
              href="https://iconscout.com/contributors/icon-mafia"
              target="_blank"
              rel="noreferrer"
            >
              Icon Mafia
            </a>
          </li>
          <li>
            <a href="https://iconscout.com">Iconscout</a>
          </li>
          <li>
            <a href="https://vecta.io">Vecta.io</a>
          </li>
        </ul>
        <h4 style={{fontSize:'small'}}>Version: Portfolio v1.0 (Beta)</h4>
      </div>
    </footer>
  );
};

export default Footer;
